import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilesService, ImageLazyLoad } from 'src/app/services/api/files.service';
import { WinService } from 'src/app/services/win.service';
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { FileManagerAddToCartComponent } from 'src/app/components/modals/file-manager-add-to-cart/file-manager-add-to-cart.component';

@Component({
	selector: 'app-files',
	templateUrl: './files.component.html',
	styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {

	modalRef: BsModalRef;

	files = null;
	filters = {
		page: 1,
		page_size: 10,
		name: ''
	}

	quickViewImage = '';

	constructor(
		public winService: WinService,
		public filesService: FilesService,
		public activeRoute: ActivatedRoute,
		public router: Router,
		public modalService: BsModalService
	) { }


	ngOnInit(): void {
		this.activeRoute.queryParams.subscribe(urlParam => {
			if(typeof urlParam.page != 'undefined'){
				this.filters.page = parseInt(urlParam.page);
			}
			if(typeof urlParam.page_size != 'undefined'){
				this.filters.page_size = parseInt(urlParam.page_size);
			}
			if(typeof urlParam.name != 'undefined'){
				this.filters.name = urlParam.name;
			}

			let url = this.filesService.getStoreUrl('/V1/lns-orderattachment/files?');

			let urlQry = [];
			if(this.filters.page){
				urlQry.push('page='+this.filters.page);
			}
			if(this.filters.page_size){
				urlQry.push('page_size='+this.filters.page_size);
			}
			if(this.filters.name){
				urlQry.push('name='+this.filters.name);
			}

			url += urlQry.join('&');

			this.filesService.doRequest(url, null, 'GET').then((data:any) => {
				if(!data.error && data.result){
					data.result.items.forEach(item => {
						this.setInitItem(item);
					});
					data.result['pages'] = [];
					this.files = data.result;
					this.setPages();

					this.filesService.setLoader(false);
				}
			});
		});
	}

	/**
	 * set the pages count for pagination buttons
	 */
	setPages() {
		
		// this.pages = [];
		// this.totalPages = Math.ceil(
		// 	this.orders.total_count / this.orders.search_criteria.page_size
		// );

		let i: any = 0;
		for (i = 1; i <= this.files.last_page_number; i++) {
			this.files.pages.push(i);
		}
	}

	setInitItem(item){
		item['is_editing'] = false;
		item['is_saving'] = false;
		item['is_view_actual_image'] = false;

		item.order_ids = item.order_ids.split(',');
		item.order_increment_ids = item.order_increment_ids.split(',');
		item.order_item_ids = item.order_item_ids.split(',');

		item['last_order_id'] = item.order_ids[item.order_ids.length - 1];
		item['last_order_increment_id'] = item.order_increment_ids[item.order_increment_ids.length - 1];

		item['initial_data'] = JSON.parse(JSON.stringify(item));
		if(typeof item.metadata == 'string'){
			item.metadata = JSON.parse(item.metadata);
		}
		this.filesService.setFileExt(item);
	}

	setIsViewActualImage(item){
		if(item.is_view_actual_image){
			item.is_view_actual_image = false;
		}
		else {
			item.is_view_actual_image = true;
		}
	}

	setIsEditing(item){
		if(item.is_editing){
			item.is_editing = false;
		}
		else {
			item.is_editing = true;
		}
	}

	setSaveItem(item){
		let url = this.filesService.getStoreUrl('/V1/lns-orderattachment/files/save');

		let jsonData = {
			id: item.id,
			original_file_name: item.original_file_name
		}

		item.is_saving = true;
		this.filesService.doRequest(url, jsonData, 'POST').then((data:any) => {
			if(!data.error && data.result){
				Object.keys(item).forEach((key) => {
					item[key] = data.result[key];
				});
				this.setInitItem(item);
			}
		});
		
		// this.setInitItem(item);
	}

	setIsEditingLg(item){
		let el =  document.getElementById('lg-input-field-' + item.id);
		el.contentEditable = "true";

		this.setIsEditing(item);
	}

	setSaveItemLg(item){
		let el =  document.getElementById('lg-input-field-' + item.id);
		el.contentEditable = "false";
		item.original_file_name = el.innerText;
		this.setSaveItem(item);
	}

	goToPage(page:any=null){
		if(page){
			this.filters.page = parseInt(page);
		}
		this.applyFilter();
	}

	startSearch(){
		this.filters.page = 1;
		this.applyFilter();
	}

	applyFilter(){
		if(this.filters.page < 1){
			this.filters.page = 1;
		}
		if(this.files.last_page_number){
			if(this.filters.page > this.files.last_page_number){
				this.filters.page = this.files.last_page_number;
			}
		} else {
			this.filters.page = 1;
		}
		let queryParams = [];
		if(this.filters.name != ''){
			queryParams.push('name='+this.filters.name);
		}

		this.filesService.setLoader(true);
		queryParams.push('page='+this.filters.page);
		this.router.navigateByUrl('/my/files?'+queryParams.join('&'));
	}

	openAddToCartModal(file){
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				file: file
			},
		};

		this.modalRef = this.modalService.show(FileManagerAddToCartComponent, config);
		this.modalRef.setClass("file-manager-add-to-cart modal-dialog-centered modal-lg");
		this.modalRef.content.onClose = (myData) => {
			this.modalRef.hide();
		};
	}

	openQuickViewArtWorkModal(item){
		item.is_view_actual_image = true;
		this.quickViewImage = "https://firebase.entrelabel.com/download.php?file=" + item.full_path;

		let elContainer = document.getElementById('quick-view-artwork-container');

		let el = document.getElementById('qva-image');
		el.setAttribute("data-imgsrc", this.quickViewImage);

		this.filesService.setLoader(true);

		let imageLazyLoad:ImageLazyLoad = new ImageLazyLoad();
		imageLazyLoad.init('lazy-load', 'lazy-loading', 'lazy-loaded', () => {
			this.filesService.setLoader(false);
			elContainer.classList.remove('d-none');
		});
	}

	closeQuickViewArtWorkModal(){
		this.quickViewImage = '';

		let elContainer = document.getElementById('quick-view-artwork-container');
		elContainer.classList.add('d-none');

		let el = document.getElementById('qva-image');
		el.removeAttribute("data-imgsrc");
		el.setAttribute("src", '');
	}

	isImage(item){
		if (item.ext == 'jpg' || item.ext == 'jpeg' || item.ext == 'png') {
			return true;
		}
		else {
			return false;
		}
	}

}
